
import { defineComponent } from 'vue';
import commonMessages from '../locales/common';
export default defineComponent({
  name: 'ReponsesCandidatsElections',
  i18n: {
    sharedMessages: commonMessages,
  },
});
